import { Component, OnInit } from '@angular/core';
import { NavigationConstant } from 'src/app/shared/constant/navigation.constant';
import { Router } from '@angular/router';

@Component({
  selector: 'app-expiry-date',
  templateUrl: './expiry-date.component.html',
  styleUrls: ['./expiry-date.component.css']
})
export class ExpiryDateComponent implements OnInit {
  currentYear = (new Date().getFullYear() + 5).toString().substr(-2);

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  goHome() {
    this.router.navigate([NavigationConstant.HOME]);
  }

}
